import React, { memo } from 'react';
import { StyleSheet, View } from 'react-native';
import { useResponsive } from '@sg/garnish';

import { LocationSearch, PageWrapper } from '@order/components';
import { useTrackEventEffect } from '@order/Telemetry';

import type { LocationsScreenProps } from '../../navigation/AppNavigation.props';
import { useReorderState } from '../ReorderingScreen';

// ─────────────────────────────────────────────────────────────────────────────

export const LocationsScreen = memo((props: LocationsScreenProps) => {
  const { params = {} } = props.route ?? {};

  const { currentBreakpoint } = useResponsive();
  const { reordering: isReordering, restaurantSlug: reorderRestaurantSlug } =
    useReorderState();

  const activeReorderRestaurantSlug = isReordering
    ? reorderRestaurantSlug
    : undefined;

  // ─── Effects ─────────────────────────────────────────────────────────

  useTrackEventEffect({
    name: 'location.view',
    payload: { orderType: params.locationSelectionType },
  });

  // ─────────────────────────────────────────────────────────────────────

  if (currentBreakpoint.isXS) {
    return (
      <View style={styles.wrapper}>
        <LocationSearch
          interactedLocationRestaurantSlug={activeReorderRestaurantSlug}
        />
      </View>
    );
  }

  return (
    <PageWrapper contentContainerStyle={styles.wrapper}>
      <LocationSearch
        interactedLocationRestaurantSlug={activeReorderRestaurantSlug}
      />
    </PageWrapper>
  );
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  wrapper: {
    height: '100%',
  },
});
